// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSalesSupport: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
            <path
                fill="currentColor"
                d="M5.59863299,7.4375 C5.59863299,6.91835934 5.17851591,6.49882787 4.66113299,6.49882787 L4.21875,6.5 C3.18339854,6.5 2.34375,7.33964854 2.34375,8.37734425 L2.34375,9.77744216 C2.34375,10.8154293 3.18457022,11.65625 4.21875,11.65625 L4.6875,11.65625 C5.20488292,11.65625 5.625,11.2355473 5.625,10.7169923 L5.59863299,7.4375 Z M7.5,0.875 C3.30761701,0.875 0.13426736,4.36425799 0.000609308481,8.375 L0,9.546875 C0,9.93652308 0.314941406,10.25 0.676757991,10.25 C1.03857458,10.25 1.40625045,9.93652308 1.40625045,9.546875 L1.40625045,8.375 C1.40625045,5.01464808 4.14082065,2.28710973 7.5,2.28710973 C10.8603524,2.28710973 13.5937504,5.01464808 13.5937504,8.375 L13.5937504,12.59375 C13.5937504,13.2409179 13.0690433,13.765625 12.4218754,13.765625 L9.17871103,13.765625 C8.93554732,13.34668 8.48730549,13.0625 7.96875045,13.0625 L7.08398491,13.0625 C6.40400425,13.0625 5.78027397,13.522168 5.65224677,14.1901364 C5.47851607,15.0898441 6.16406277,15.875 7.00488344,15.875 L7.96875045,15.875 C8.48789111,15.875 8.93642619,15.5904981 9.17988315,15.171875 L12.4218754,15.171875 C13.8457038,15.171875 15,14.0175783 15,12.59375 L15,8.375 C14.8652346,4.36425799 11.6923834,0.875 7.5,0.875 L7.5,0.875 Z M10.7812504,11.65625 C11.8166019,11.65625 12.6562504,10.8154293 12.6562504,9.77744126 L12.6562504,8.37792987 C12.6562504,7.34082022 11.8154298,6.5 10.7812504,6.5 L10.3125004,6.5 C9.79511753,6.5 9.37500045,6.92011708 9.37500045,7.43867213 L9.37500045,10.7158201 C9.37500045,11.237305 9.7939454,11.65625 10.3125004,11.65625 L10.7812504,11.65625 Z"
            />
        </svg>
    );
};

export default React.memo(IconSalesSupport);
